import React, { FC } from 'react'
import styles from './SearchComponents.module.scss'
import CloseIcon from 'svg/SA/close-x-small.svg'
import { SearchOptionLinksProps } from './SearchOptionLinks'
import OptionRowLink from './OptionRowLink'
import classNames from 'classnames'

type OptionLinksProps = Pick<
  SearchOptionLinksProps,
  | 'options'
  | 'setIsFocused'
  | 'onRemove'
  | 'onSearch'
  | 'matchedTerm'
  | 'highlightMatchedTerms'
  | 'icon'
  | 'sectionName'
>

const OptionLinks: FC<OptionLinksProps> = ({
  onRemove,
  options,
  setIsFocused,
  onSearch,
  matchedTerm,
  highlightMatchedTerms,
  icon,
  sectionName,
}) => {
  return options.map(({ label, link }) => {
    const OptionLinkComponent = (
      <OptionRowLink
        label={label}
        link={link}
        setIsFocused={setIsFocused}
        onSearch={onSearch}
        matchedTerm={matchedTerm}
        highlightMatchedTerms={highlightMatchedTerms}
        icon={icon}
        sectionName={sectionName}
      />
    )

    const handleRemove = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      event.preventDefault()
      onRemove?.(label)
    }

    if (!onRemove) {
      return OptionLinkComponent
    }

    return (
      <div
        key={label}
        className={classNames(styles.hoverWithCloseContainer, {
          [styles.hoverWithCloseContainerHeight]: options.length === 1,
        })}
      >
        {OptionLinkComponent}
        <div className={styles.closeIconBox} onMouseDown={handleRemove}>
          <CloseIcon />
        </div>
      </div>
    )
  })
}

export default OptionLinks
